import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useNotifications from '@lib/hooks/notifications';
import { Slot, If, createPage } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, Loader, Flex, Button, DocumentTitle } = shared;

import styles from './index.module.scss';
import { useAuthStore } from '@/stores/auth'; 
import checkoutApi from '@/apis/drupal/checkout';
import DeveloperLayout from '@/layouts/DeveloperLayout';

const PRODUCT_1 = 3974;
const PRODUCT_2 = 3977;
const PRODUCT_3 = 3978;

export default createPage('PurchaseTokensPage', { styles }, function PurchaseTokensPage ({ className }) {
  const [ state ] = useAuthStore();
  const router = useRouter();
  const { notify } = useNotifications();
  
  // Redirect to login if not logged in
  useEffect(() => {
    if (state.ready && !state.auth) {
      router.replace('/');
      return;
    }
  }, [ state ]);

  const purchaseTokens = async (product) => {
    const result = await checkoutApi.checkout(product, state.token);

    if (result.error) {
      notify('There was an error completing your purchase. Please try again later.');
      return;
    }

    window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/iog-stripe-checkout`;
  };

  useEffect(() => {
    if (!window.location.search) return;
    notify('There was an error completing your purchase. Please try again later.');
    router.replace(window.location.href.split('?')[0], undefined, { shallow: true });
  }, []);

  return (
    <>
      <DocumentTitle title='Shop' />
      
      <DeveloperLayout className={className}>
        {
          If(!state.ready, () => (
            <Loader.Fill large />
          ))
          .ElseIf(state.ready && !!state.auth, () => (
            <Box>
              <Block>
                <Block>
                  <Title>Purchase Tokens</Title>
                </Block>
                <br />
                <Block>
                  <Flex container gap2 collapseMobile>
                    <Flex>
                      <Flex 
                        onClick={() => purchaseTokens(PRODUCT_1)}
                        className='PurchaseTokensPage__Option' 
                        directionColumn 
                        alignCenter
                      >
                        <img src='/images/Tier1.svg' />
                        <p className='--marMd1__t'><strong>1</strong> token - $30.00 USD</p>
                        <p><strong>No Savings</strong></p>
                        <Button primary className='--marMd1__t'>Buy 1 Token</Button>
                      </Flex>
                    </Flex>
                    <Flex>
                      <Flex 
                        onClick={() => purchaseTokens(PRODUCT_2)}
                        className='PurchaseTokensPage__Option' 
                        directionColumn 
                        alignCenter
                      >
                        <img src='/images/Tier2.svg' />
                        <p className='--marMd1__t'><strong>7</strong> tokens - $175.00 USD</p>
                        <p><strong>Save $35</strong></p>
                        <Button primary className='--marMd1__t'>Buy 7 Tokens</Button>
                      </Flex>
                    </Flex>
                    <Flex>
                      <Flex 
                        onClick={() => purchaseTokens(PRODUCT_3)}
                        className='PurchaseTokensPage__Option' 
                        directionColumn 
                        alignCenter
                      >
                        <img src='/images/Tier3.svg' />
                        <p className='--marMd1__t'><strong>30</strong> tokens - $750.00 USD</p>
                        <p><strong>Save $150</strong></p>
                        <Button primary className='--marMd1__t'>Buy 30 Tokens</Button>
                      </Flex>
                    </Flex>
                  </Flex>
                </Block>
              </Block>
            </Box>
          ))
          .EndIf()
        } 
      </DeveloperLayout>
    </>
  )
});
